import { render, staticRenderFns } from "./DecideOnDropout.vue?vue&type=template&id=b3e4477e&"
import script from "./DecideOnDropout.vue?vue&type=script&lang=js&"
export * from "./DecideOnDropout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports